var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"floating-button btn btn-info",attrs:{"variant":"primary","size":"lg"},on:{"click":function($event){return _vm.refresh()}}},[_c('i',{staticClass:"uil-refresh"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }